import { ISelectOption } from '@/coreDomainsModule/table';
import { defineStore } from 'pinia';

/**
 * yearMonthPicker.vueのstoreを管理する
 */
export const useYearMonthPickerStore = defineStore('yearMonthPicker', () => {
  /**
   * SelectedFieldに設定する値を決定する
   * @param newDate - 日付
   */
  const initSelectedYearValue = (newDate: Date) => {
    const year = newDate.getFullYear();
    const output: Set<ISelectOption> = new Set();
    // 10年先までの年情報の生成
    for (let i = 0; i <= 10; i++) {
      output.add({
        label: `${year + i}`,
        value: year + i,
      });
    }
    // 10年前までの年情報の生成
    for (let i = 1; i <= 10; i++) {
      output.add({
        label: `${year - i}`,
        value: year - i,
      });
    }
    const outputArray = Array.from(output);
    outputArray.sort(compareSelectInfo);
    return outputArray;
  };

  /**
   * SelectedFieldに設定する値を決定する
   */
  const initSelectedMonthValue = () => {
    const output: Set<ISelectOption> = new Set();
    // 12ヶ月分の月情報を生成
    for (let i = 0; i < 12; i++) {
      output.add({
        label: `${i + 1}`,
        value: i,
      });
    }
    const outputArray = Array.from(output);
    outputArray.sort(compareSelectInfo);
    return outputArray;
  };

  /**
   * 選択肢の年・月情報配列を比較する用
   * @param a - a
   * @param b - b
   */
  const compareSelectInfo = (a: ISelectOption, b: ISelectOption): number => {
    if (a.value > b.value) return 1;
    if (a.value < b.value) return -1;
    if (a.value === b.value) return 0;
    return 0;
  };

  return {
    initSelectedYearValue,
    initSelectedMonthValue,
  };
});
